import { Pipe, PipeTransform } from '@angular/core';
import { SelectEditField, DynamicFormOptions } from '../models/edit-fields';
import { DynamicFormApi } from '../services/dynamic-form.api';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'selectObservable',
    standalone: false
})
export class SelectObservablePipe implements PipeTransform {
  constructor(private editFormApi: DynamicFormApi) {}

  transform(
    field: SelectEditField,
    options: DynamicFormOptions
  ): Observable<{ key: string; value: string }[]> {
    if (field.options && !field.optionsUrl) {
      return of(
        field.options.map((option) => ({ key: option, value: option }))
      );
    }

    return this.editFormApi.getSelectOptions(options, field.optionsUrl).pipe(
      map((response: Array<any>) => {
        return response.map((item) => ({
         
          key: item[field.optionsUrlProperty],
          value: item[field.optionsUrlValue],
        }));
      })
    );
  }
}
